import dayjs from 'dayjs';
import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { useGlobalContext } from '../../contexts/GlobalContext';
import { useTableContext } from '../../contexts/TableContext';
import RoutesApp from '../../routes';

//Servicios
import { DeclaracionesService } from '../../services/api';

//Componentes
import Spinner from '../spinner/Spinner';
import DJCPSearch from './DJCPSearch';

//Estilos
import right_arrow from '../../assets/imgs/next.png';
import pencil from '../../assets/imgs/edit.png';

function DJCPSearchContainer() {
    const { masters, SearchParameters } = useGlobalContext();
    const { state } = useTableContext();
    const tablePage = useMemo(() => state.DJCPPage, [state.DJCPPage]);
    const [loader, setLoader] = useState(false);
    const [tableData, setTableData] = useState(buildTableData());
    let apiTablePages;

    useEffect(() => {
        const getDJCPSearchQuantity = async () => {
            try {
                setLoader(true);

                const DJCPSearchCuantity =
                    await DeclaracionesService.totalRecords({
                        ...SearchParameters.declaraciones,
                        tipo: 4,
                    });

                if (DJCPSearchCuantity) {
                    apiTablePages = DJCPSearchCuantity.data;

                    getDJCPSearch();
                }

                setLoader(false);
            } catch (err) {
                setLoader(false);
                return err;
            }
        };

        getDJCPSearchQuantity();
    }, [tablePage, SearchParameters.declaraciones]);

    async function getDJCPSearch() {
        try {
            setLoader(true);

            const DJCPSearch = await DeclaracionesService.search({
                ...SearchParameters.declaraciones,
                tipo: 4,
                pagina: tablePage,
            });

            if (DJCPSearch) {
                setTableData(buildTableData(DJCPSearch.data, apiTablePages));
            }

            setLoader(false);
        } catch (err) {
            setLoader(false);
            return err;
        }
    }

    /**Funcion que crea el objeto para crear la tabla resultado del buscador de DJCPs */
    function buildTableData(data = [], tablePages) {
        return {
            title: 'Declaraciones de Cosecha Probable',
            headers: [
                'ID',
                'Viñedo',
                'Titulares',
                'Fecha',
                'Departamento',
                'Seccional',
                ' ',
            ],
            tablePages,
            pagination: 10,
            pageType: 'DJCPPage',
            data:
                data.length > 0
                    ? data.map((dj) => {
                          return {
                              id: `${dj.serie}-P-${dj.numero}`,
                              viniedo: dj.viniedo,
                              titulares: dj.titulares,
                              fecha: dayjs(dj.fecha).format('DD-MM-YYYY'),
                              departamento: masters.Departments?.find(
                                  (ht) => ht.id === dj.departamento
                              )?.nombre.replaceAll('_', ' '),
                              kilosTotales: dj.seccional,
                              icons: (
                                  <div>
                                      <Link
                                          to={
                                              RoutesApp.Declaraciones
                                                  .cosechaProbable + dj.id
                                          }
                                          className="table-icon_container"
                                      >
                                          <img
                                              className="table-icon"
                                              src={right_arrow}
                                              title="Visualizar"
                                              alt="Visualizar"
                                          />
                                      </Link>
                                  </div>
                              ),
                          };
                      })
                    : [],
        };
    }

    return loader ? <Spinner /> : <DJCPSearch tableData={tableData} />;
}

export default DJCPSearchContainer;
